const ListBulleted = () => (
  <>
    <path
      fill="currentColor"
      d="M10 17.5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 10 16.5h8q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356A.49.49 0 0 1 18 17.5zm0-5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.212.144-.356A.49.49 0 0 1 10 11.5h8q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .212-.144.356A.49.49 0 0 1 18 12.5zm0-5a.48.48 0 0 1-.356-.144.49.49 0 0 1-.144-.357q0-.213.144-.356A.49.49 0 0 1 10 6.5h8q.212 0 .356.144a.49.49 0 0 1 .144.357q0 .213-.144.356A.49.49 0 0 1 18 7.5zM7.5 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.5 12a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7.5 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
    />
  </>
)
export default ListBulleted
